/**
 * Piletilevi report-api services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * All returns report for all sales, own returns report for own salespoint sales, alias returns report for alias salespoint sales
 */
export type SalespointReportScopeEnum = 'ALL' | 'OWN' | 'ALIAS';

export const SalespointReportScopeEnum = {
    All: 'ALL' as SalespointReportScopeEnum,
    Own: 'OWN' as SalespointReportScopeEnum,
    Alias: 'ALIAS' as SalespointReportScopeEnum
};

